import { api } from "../utils/api";

const getEngagementGraph = async () => {
  const res = await api.get("/SchoolManagements/indicators/engagement");
  return res.data;
};

const getAccessionGraphs = async () => {
  const res = await api.get("/SchoolManagements/accessionGraphs");
  return res.data;
};

export default {
  getEngagementGraph,
  getAccessionGraphs
};
